<template>
  <div class="home-screen-section-layout @container w-screen">
    <div class="flex flex-col-reverse lg:flex-row">
      <aside class="home-screen-section-layout__quick-access flex pl-8">
        <slot name="quickAccess" />
      </aside>
      <div
        class="home-screen-section-layout__main flex-1 lg:ml-12 xl:ml-20 2xl:ml-36 mx-6 sm:mx-8 overflow-hidden"
      >
        <template v-for="sectionKey in mainSectionKeys" :key="sectionKey">
          <slot :name="sectionKey" />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Renders home screen sections via named Vue slots in CMS/layout sort order.
 * Quick access (`content.quickAccessLinks`) is always shown in the side column and is not part of homeScreenLayout.
 */
export default {
  name: 'HomeScreenSectionLayout',
  props: {
    /** Enabled sections sorted by `sortOrder` (from login / homeScreenLayout). */
    sections: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    mainSectionKeys() {
      return this.sections.map((s) => s.sectionKey).filter(Boolean);
    },
  },
};
</script>
